export default class JsonHelper {

    public static Deserialize(data: string): any {
        return JSON.parse(data, JsonHelper.ReviveDateTime);
    }

    private static ReviveDateTime(key: any, value: any): any {
        if (typeof value === 'string') {
            const regex = /[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}./g;
            if (value.match(regex)) {
                return new Date(value);
            }
        }

        return value;
    }
}